import { CREATE_A_CLONE_OF_AN_ASSISTANT, CREATE_N_CLONE_OF_AN_ASSISTANT } from "../constants/Api_constants";
import { axiosSecureInstance } from "./axios";
import { getUserID } from "../Utility/service";
import { message } from "antd";

export const personalizeAssistant = async (assistantId) => {
    const userId = getUserID();

     try {

        const payload = {
            assistantId: assistantId,
            userId: userId,
        };

        const response = await axiosSecureInstance.post(CREATE_A_CLONE_OF_AN_ASSISTANT(assistantId), payload);


        if (response.status === 201) {
            const newAssistantId = response.data?.assistantId || assistantId;
            message.success(response.data.message);
            console.log("🎉 Assistant cloned successfully. New ID:", newAssistantId);

            return {
                message: response.data.message,
                success: true,
                newAssistantId: newAssistantId,
            };
        } else {
            message.error(response.data.message);
            console.warn("Unexpected status code:", response.status, "Message:", response.data.message);

            return {
                message: response.data.message,
                success: false,
            };
        }
   } catch (error) {
        const errMsg = error.response?.data?.message || "Something went wrong";
        message.error(errMsg);
        return {
            message: errMsg,
            success: false,
        };
    }
};

export const personalizeMultiAssistant = async (assistantId) => {
    const userId = getUserID();
    
     try {

        const payload = {
            assistantId: assistantId,
            userId: userId,
        };

        const response = await axiosSecureInstance.post(CREATE_N_CLONE_OF_AN_ASSISTANT(assistantId), payload);


        if (response.status === 201) {
            const newAssistantId = response.data?.assistantId || assistantId;
            // message.success(response.data.message);

            return {
                message: response.data.message,
                success: true,
                newAssistantId: newAssistantId,
            };
        } else {
            message.error(response.data.message);
            console.warn("Unexpected status code:", response.status, "Message:", response.data.message);

            return {
                message: response.data.message,
                success: false,
            };
        }
   } catch (error) {
        const errMsg = error.response?.data?.message || "Something went wrong";
        message.error(errMsg);

        return {
            message: errMsg,
            success: false,
        };
    }
  };
